import React from 'react';

import CommonImage from '@/components/CommonImage';
import DashboardCard from '@/features/task-configuration/components/DashboardCard';

const DashboardSectionTab = ({
	isExpanded,
	setIsExpanded,
	cards,
	handleEditCard,
	handleDeleteCard,
	isReadOnly = false,
	isShowCount = false,
	shouldDisableFilter = false,
	taskListCount = {},
	isLoadingDashboardTaskCount = false
}) => {
	return (
		<div className="other-tasks-body p-3 d-flex justify-content-between align-items-center">
			<div className={`other-tasks-content w-100 ${isExpanded ? 'expanded' : ''}`}>
				<div className="other-single-tasks d-grid gap-4 grid-columns-4">
					{cards.map((card) => (
						<DashboardCard
							key={card.id}
							card={card}
							onEdit={handleEditCard}
							onDelete={handleDeleteCard}
							isReadOnly={isReadOnly}
							isShowCount={isShowCount}
							shouldDisableFilter={shouldDisableFilter}
							taskListCount={taskListCount}
							isLoadingDashboardTaskCount={isLoadingDashboardTaskCount}
						/>
					))}
				</div>
			</div>
			<div
				className={`collaps-btn cursor-pointer ml-2 ${isExpanded ? ' rotate-180' : ''}`}
				onClick={() => setIsExpanded((prev) => !prev)}
			>
				<CommonImage src="/icons/angel-bottom.svg" width={16} height={16} />
			</div>
		</div>
	);
};

export default DashboardSectionTab;
